import { Freight } from '../../../contexts/RouterContext'

export function formatRouteDate(isoDateString: string): string {
  if (!isoDateString) return '-'

  const dateUtc = new Date(isoDateString)
  if (isNaN(dateUtc.getTime())) return '-'

  const year = dateUtc.getUTCFullYear()
  const month = dateUtc.getUTCMonth() + 1
  const day = dateUtc.getUTCDate()
  const formattedMonth = month < 10 ? `0${month}` : String(month)
  const formattedDay = day < 10 ? `0${day}` : String(day)

  return `${formattedDay}/${formattedMonth}/${year}`
}

export function formatFullAddress(freight: Freight): string {
  if (freight.type === 'Sem endereço' || !freight.Address) return ''

  const parts: string[] = []
  const addr = freight.Address

  if (addr.street) parts.push(addr.street)
  if (addr.Neighborhood?.name) parts.push(addr.Neighborhood.name)
  if (addr.number) parts.push(String(addr.number))
  if (addr.Neighborhood?.City?.name) parts.push(addr.Neighborhood.City.name)

  let result = parts.join(', ')
  if (addr.complement) {
    result += result ? ` — ${addr.complement}` : addr.complement
  }

  return result
}

export function formatLoadInfo(
  load: Freight['Load'],
  orderNumber?: string,
): string {
  if (!load) return '-'

  const parts: string[] = []

  if (Number(load.weight) > 0) {
    parts.push(`${Number(load.weight).toLocaleString('pt-BR')}kg`)
  }

  const dims: string[] = []
  if (Number(load.length) > 0) dims.push(Number(load.length).toLocaleString('pt-BR'))
  if (Number(load.width) > 0) dims.push(Number(load.width).toLocaleString('pt-BR'))
  if (Number(load.height) > 0) dims.push(Number(load.height).toLocaleString('pt-BR'))
  if (dims.length > 0) parts.push(`${dims.join('×')}m`)

  if (Number(load.cubage) > 0) {
    parts.push(`${Number(load.cubage).toLocaleString('pt-BR')}m³`)
  }

  if (load.detail) parts.push(`Detalhe: ${load.detail}`)
  if (orderNumber) parts.push(`Pedido: ${orderNumber}`)

  return parts.length > 0 ? parts.join(' | ') : '-'
}

export function parseTrack(track?: string): { time: string; distance: string } {
  if (!track) return { time: '-', distance: '-' }

  const parts = track.split('-')
  return {
    time: parts[0]?.trim() || '-',
    distance: parts[1]?.trim() || '-',
  }
}

export function sortFreights(freights: Freight[]): Freight[] {
  return [...freights].sort((a, b) => {
    const indexA = (a as Freight & { index?: number }).index
    const indexB = (b as Freight & { index?: number }).index

    if (indexA != null && indexB != null) return indexA - indexB
    if (indexA != null) return -1
    if (indexB != null) return 1
    return 0
  })
}
